import { render, staticRenderFns } from "./Bracelet.vue?vue&type=template&id=52eacc14&scoped=true&"
import script from "./Bracelet.vue?vue&type=script&lang=js&"
export * from "./Bracelet.vue?vue&type=script&lang=js&"
import style0 from "./Bracelet.vue?vue&type=style&index=0&id=52eacc14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eacc14",
  null
  
)

export default component.exports